"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));

var _ExpandableContentBlock = _interopRequireDefault(require("@airasia/phoenix-components/components/ExpandableContentBlock"));

var _ExpandableTextContainer = _interopRequireDefault(require("./ExpandableTextContainer.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "ExpandableTextContainer__StyledWrapper",
  componentId: "sc-1wa2377-0"
})(["margin-bottom:10px;"]);

StyledWrapper.displayName = 'StyledWrapper';

var ShowMoreContainer = _styledComponents.default.div.withConfig({
  displayName: "ExpandableTextContainer__ShowMoreContainer",
  componentId: "sc-1wa2377-1"
})(["display:", ";"], function (props) {
  return props.show ? 'none' : 'inline';
});

ShowMoreContainer.displayName = 'ShowMoreContainer';

var ExpandedContainer = _styledComponents.default.div.withConfig({
  displayName: "ExpandableTextContainer__ExpandedContainer",
  componentId: "sc-1wa2377-2"
})(["display:", ";"], function (props) {
  return props.show ? 'inline' : 'none';
});

ExpandedContainer.displayName = 'ExpandedContainer';

var RenderContainer = function RenderContainer(props) {
  var data = props.data,
      dataProperties = props.dataProperties,
      dataSliceLimit = props.dataSliceLimit,
      expandCtaText = props.expandCtaText,
      compressCtaText = props.compressCtaText,
      ctaColor = props.ctaColor,
      ctaSize = props.ctaSize,
      ctaUnderlined = props.ctaUnderlined,
      ctaHoverColor = props.ctaHoverColor,
      ctaHoverUnderlined = props.ctaHoverUnderlined,
      accessible = props.accessible;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showMoreToggle = _useState2[0],
      setShowMoreToggle = _useState2[1];

  var sliceLimit = dataSliceLimit || data.length;

  var showMoreClick = function showMoreClick() {
    setShowMoreToggle(!showMoreToggle);
  };

  var ctaLinkProps = {
    callback: showMoreClick,
    // eslint-disable-next-line no-script-url
    href: 'javascript:void(0);',
    target: 'callback',
    size: ctaSize,
    color: ctaColor,
    underlined: ctaUnderlined,
    hoverColor: ctaHoverColor,
    hoverUnderlined: ctaHoverUnderlined,
    accessible: accessible
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.slice(0, sliceLimit).map(function (item) {
    return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
      key: item.title
    }, /*#__PURE__*/_react.default.createElement(_ExpandableContentBlock.default, (0, _extends2.default)({}, item, dataProperties, {
      accessible: accessible
    })));
  }), sliceLimit < data.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ShowMoreContainer, {
    show: showMoreToggle
  }, /*#__PURE__*/_react.default.createElement(_Link.default, ctaLinkProps, expandCtaText)), /*#__PURE__*/_react.default.createElement(ExpandedContainer, {
    show: showMoreToggle
  }, data.slice(sliceLimit).map(function (item) {
    return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
      key: item.title
    }, /*#__PURE__*/_react.default.createElement(_ExpandableContentBlock.default, (0, _extends2.default)({}, item, dataProperties, {
      accessible: accessible
    })));
  }), /*#__PURE__*/_react.default.createElement(_Link.default, ctaLinkProps, compressCtaText))));
};

var ExpandableTextContainer = function ExpandableTextContainer(props) {
  var theme = props.theme;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return themeContext ? /*#__PURE__*/_react.default.createElement(RenderContainer, props) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(RenderContainer, props));
};

RenderContainer.propTypes = _ExpandableTextContainer.default.PropTypes;
ExpandableTextContainer.propTypes = _ExpandableTextContainer.default.PropTypes;
ExpandableTextContainer.defaultProps = _ExpandableTextContainer.default.DefaultProps;
ExpandableTextContainer.displayName = 'ExpandableTextContainer';
var _default = ExpandableTextContainer;
exports.default = _default;